import { render, staticRenderFns } from "./World.pug?vue&type=template&id=2366db2a&"
import script from "./World.js?vue&type=script&lang=js&"
export * from "./World.js?vue&type=script&lang=js&"
import style0 from "./World.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports